import { yachSdk } from './lib';
/*biz*****************************/
/**util*/
import { openLink } from './api/biz/util/openLink';
import { feedback } from './api/biz/util/feedback';
import { open } from './api/biz/util/open';
import { openSlidePanel } from './api/biz/util/openSlidePanel';
import { share } from './api/biz/util/share';
import { previewFile } from './api/biz/util/previewFile';
import { previewImage } from './api/biz/util/previewImage';
import { downloadFile } from './api/biz/util/downloadFile';
import { uploadAttachment } from './api/biz/util/uploadAttachment';
import { clipboardFileUpload } from './api/biz/util/clipboardFileUpload';
import { proxy } from './api/biz/util/proxy';
import { datepicker } from './api/biz/util/datepicker';
import { datetimepicker } from './api/biz/util/datetimepicker';
import { scan } from './api/biz/util/scan';
import { view as mapView } from './api/biz/map/view';
import { multipointView } from './api/biz/map/multipointView';
import { chosen } from './api/biz/util/chosen';
import { openSingleWebview } from './api/biz/util/openSingleWebview';
import { getSingleWebviewData } from './api/biz/util/getSingleWebviewData';
import { injectScript } from './api/biz/util/injectScript';
import { closeWindow } from './api/biz/util/closeWindow';
import { remind } from './api/biz/util/remind';
import { takePicture } from './api/biz/util/takePicture';
import { openVideoPlayer } from './api/biz/util/openVideoPlayer';
import { openMediaFileDialog } from './api/biz/util/openMediaFileDialog';
import { mediaFileUpload } from './api/biz/util/mediaFileUpload';
import { invoice } from './api/biz/util/invoice';
import { pushWorkMsg } from './api/biz/util/pushWorkMsg';
import { openTalYoungToTopic } from './api/biz/util/openTalYoungToTopic';
import { getToken } from './api/biz/util/getToken';
import { authStart } from './api/biz/util/authStart';
import { authFinish } from './api/biz/util/authFinish';
import { assistantCreate } from './api/biz/util/assistantCreate';
import { yachEvent } from './api/biz/util/yachEvent';
import { openTogetherEyeWebview } from './api/biz/util/openTogetherEyeWebview';
import { getTogetherConfig } from './api/biz/util/getTogetherConfig';
import { rouseApp } from './api/biz/util/rouseApp';
import { externalLinkPreviewFile } from './api/biz/util/externalLinkPreviewFile';
import { zfbAuth } from './api/biz/util/zfbAuth';
import { savePic } from './api/biz/util/savePic';
import { complain } from './api/biz/util/complain';
import { selectDepartment } from './api/biz/util/selectDepartment';
import { createModifySchedule } from './api/biz/util/createModifySchedule';
import { openUserSchedule } from './api/biz/util/openUserSchedule';
import { onlineDocmentOpenTeamChat } from './api/biz/util/onlineDocmentOpenTeamChat';
import { entergroupCheck } from './api/biz/util/entergroupCheck';
import { resetSessionUnread } from './api/biz/util/resetSessionUnread';
import { disableScreenCapture } from './api/biz/util/disableScreenCapture';
import { openFutureGroup } from './api/biz/util/openFutureGroup';
import { knowledgeBaseSelect } from './api/biz/util/knowledgeBaseSelect';
/**navigation*/
import { setIcon } from './api/biz/navigation/setIcon';
import { setTitle } from './api/biz/navigation/setTitle';
import { setMenu } from './api/biz/navigation/setMenu';
import { close } from './api/biz/navigation/close';
import { replace as replacePage } from './api/biz/navigation/replace';
import { quit } from './api/biz/navigation/quit';
import { setRight } from './api/biz/navigation/setRight';
import { setTitleExpandIcon } from './api/biz/navigation/setTitleExpandIcon';
import { updateExpandTitle } from './api/biz/navigation/updateExpandTitle';
import { setLeft } from './api/biz/navigation/setLeft';
import { goBack } from './api/biz/navigation/goBack';
import { setWindowBig } from './api/biz/navigation/setWindowBig';
import { tencentMeeting } from './api/biz/navigation/tencentMeeting';
import { tencentMeetingBegin } from './api/biz/navigation/tencentMeetingBegin';
import { setPanGestureEnable } from './api/biz/navigation/setPanGestureEnable';
/**contact*/
import { complexPicker } from './api/biz/contact/complexPicker';
import { departmentsPicker } from './api/biz/contact/departmentsPicker';
/** group*/
import { groupComplexPicker } from './api/biz/group/groupComplexPicker';
/** chat*/
import { chooseConversationByCorpId } from './api/biz/chat/chooseConversationByCorpId';
import { pickConversation } from './api/biz/chat/pickConversation';
import { openSingleChat } from './api/biz/chat/openSingleChat';
import { openTeamChat } from './api/biz/chat/openTeamChat';
import { openSquad } from './api/biz/chat/openSquad';
import { sendP2PMsg } from './api/biz/chat/sendP2PMsg';
/* primary*****************************/
import { createTab } from './api/primary/createTab';
import { weeklyShare } from './api/primary/weeklyShare';
import { fullScreen } from './api/primary/fullScreen';
import { exitFullScreen } from './api/primary/exitFullScreen';
/* runtime*****************************/
import { requestAuthCode } from './api/runtime/permission/requestAuthCode';
/** device */
import { showPreloader } from './api/device/notification/showPreloader';
import { hidePreloader } from './api/device/notification/hidePreloader';
import { vibrate } from './api/device/notification/vibrate';
import { toast } from './api/device/notification/toast';
import { actionSheet } from './api/device/notification/actionSheet';
import { getPhoneInfo } from './api/device/base/getPhoneInfo';
import { alert } from './api/device/notification/alert';
import { confirm } from './api/device/notification/confirm';
import { get as getGeolocation } from './api/device/geolocation/get';
import { getSwitch as getGeolocationSwitch } from './api/device/geolocation/getSwitch';
import { getLang } from './api/device/system/getLang';
import { startRecord } from './api/device/audio/startRecord';
import { stopRecord } from './api/device/audio/stopRecord';
import { onRecordEnd } from './api/device/audio/onRecordEnd';
import { download as downloadAudio } from './api/device/audio/download';
import { play as playAudio } from './api/device/audio/play';
import { pause as pauseAudio } from './api/device/audio/pause';
import { stop as stopAudio } from './api/device/audio/stop';
import { onPlayEnd } from './api/device/audio/onPlayEnd';
import { resume as resumeAudio } from './api/device/audio/resume';
import { getNetworkType } from './api/device/connection/getNetworkType';
import { isAtTal } from './api/device/connection/isAtTal';
import { getUUID } from './api/device/base/getUUID';
import { checkStepPermission } from './api/device/base/checkStepPermission';
import { onRecordEnd_v2 } from './api/device/audio/onRecordEnd_v2';
import { startRecord_v2 } from './api/device/audio/startRecord_v2';
import { stopRecord_v2 } from './api/device/audio/stopRecord_v2';
import { setLight } from './api/device/system/setLight';
/** telephone */
import { showCallMenu } from './api/biz/telephone/showCallMenu';
import { call } from './api/biz/telephone/call';
/** ui */
import { disable as webViewBounceDisable } from './api/ui/webViewBounce/disable';
import { enable as pullToRefreshEnable } from './api/ui/pullToRefresh/enable';
import { stop as pullToRefreshStop } from './api/ui/pullToRefresh/stop';
import { disable as pullToRefreshDisable } from './api/ui/pullToRefresh/disable';
// demainStorage
import { getItem } from './api/util/domainStorage/getItem';
import { setItem } from './api/util/domainStorage/setItem';
import { removeItem } from './api/util/domainStorage/removeItem';
// log
import { writeLog } from './api/util/tool/log';
import { flushLog } from './api/util/tool/flushLog';
import { send as webViewMessageSend } from './api/biz/webViewMessage/send';
import { talYoungFilesUpload } from './api/app/custom/talYoungFilesUpload';
import { addAppToNav } from './api/biz/util/addAppToNav';
console.log('add rouseApp ------------>', rouseApp);
var _yachSdk$exportSdk = yachSdk.exportSdk,
  version = _yachSdk$exportSdk.version,
  sdkVersion = _yachSdk$exportSdk.sdkVersion,
  env = _yachSdk$exportSdk.env,
  platform = _yachSdk$exportSdk.platform,
  platformV2 = _yachSdk$exportSdk.platformV2,
  config = _yachSdk$exportSdk.config,
  ready = _yachSdk$exportSdk.ready,
  error = _yachSdk$exportSdk.error,
  on = _yachSdk$exportSdk.on,
  off = _yachSdk$exportSdk.off;
export { version, sdkVersion, env, platform, platformV2, config, ready, error, on, off, openLink, feedback, open, openSlidePanel, share, previewFile, previewImage, downloadFile, uploadAttachment, clipboardFileUpload, proxy, datepicker, scan, chosen, openSingleWebview, getSingleWebviewData, injectScript, closeWindow, showCallMenu, call, setIcon, setTitle, setMenu, close, replacePage, quit, setRight, setTitleExpandIcon, updateExpandTitle, setLeft, goBack, complexPicker, departmentsPicker, groupComplexPicker, chooseConversationByCorpId, pickConversation, openSingleChat, openTeamChat, openSquad, sendP2PMsg, mapView, multipointView, requestAuthCode, createTab, weeklyShare, fullScreen, exitFullScreen, showPreloader, hidePreloader, vibrate, toast, alert, confirm, getPhoneInfo, getUUID, checkStepPermission, getGeolocation, getGeolocationSwitch, getLang, startRecord, stopRecord, onRecordEnd, downloadAudio, playAudio, pauseAudio, stopAudio, onPlayEnd, resumeAudio, getNetworkType, isAtTal, webViewBounceDisable, pullToRefreshEnable, pullToRefreshStop, pullToRefreshDisable, getItem, setItem, removeItem, writeLog, flushLog, remind, takePicture, datetimepicker, actionSheet, webViewMessageSend, talYoungFilesUpload, openVideoPlayer, openMediaFileDialog, mediaFileUpload, invoice, pushWorkMsg, openTalYoungToTopic, getToken, authStart, authFinish, assistantCreate, yachEvent, openTogetherEyeWebview, getTogetherConfig, rouseApp, externalLinkPreviewFile, savePic, zfbAuth, complain, onRecordEnd_v2, startRecord_v2, stopRecord_v2, selectDepartment, setWindowBig, tencentMeeting, tencentMeetingBegin, createModifySchedule, onlineDocmentOpenTeamChat, entergroupCheck, resetSessionUnread, openFutureGroup, knowledgeBaseSelect, setLight, openUserSchedule, disableScreenCapture, setPanGestureEnable, addAppToNav };
export default {
  version: version,
  sdkVersion: sdkVersion,
  env: env,
  platform: platform,
  platformV2: platformV2,
  config: config,
  ready: ready,
  error: error,
  on: on,
  off: off,
  biz: {
    util: {
      openLink: openLink,
      feedback: feedback,
      open: open,
      openSlidePanel: openSlidePanel,
      share: share,
      previewFile: previewFile,
      previewImage: previewImage,
      downloadFile: downloadFile,
      uploadAttachment: uploadAttachment,
      clipboardFileUpload: clipboardFileUpload,
      proxy: proxy,
      datepicker: datepicker,
      datetimepicker: datetimepicker,
      scan: scan,
      chosen: chosen,
      openSingleWebview: openSingleWebview,
      getSingleWebviewData: getSingleWebviewData,
      injectScript: injectScript,
      onlineDocmentOpenTeamChat: onlineDocmentOpenTeamChat,
      entergroupCheck: entergroupCheck,
      resetSessionUnread: resetSessionUnread,
      openFutureGroup: openFutureGroup,
      closeWindow: closeWindow,
      remind: remind,
      takePicture: takePicture,
      openVideoPlayer: openVideoPlayer,
      openMediaFileDialog: openMediaFileDialog,
      mediaFileUpload: mediaFileUpload,
      invoice: invoice,
      pushWorkMsg: pushWorkMsg,
      openTalYoungToTopic: openTalYoungToTopic,
      getToken: getToken,
      authStart: authStart,
      authFinish: authFinish,
      assistantCreate: assistantCreate,
      yachEvent: yachEvent,
      openTogetherEyeWebview: openTogetherEyeWebview,
      getTogetherConfig: getTogetherConfig,
      rouseApp: rouseApp,
      externalLinkPreviewFile: externalLinkPreviewFile,
      savePic: savePic,
      zfbAuth: zfbAuth,
      complain: complain,
      selectDepartment: selectDepartment,
      createModifySchedule: createModifySchedule,
      openUserSchedule: openUserSchedule,
      disableScreenCapture: disableScreenCapture,
      addAppToNav: addAppToNav,
      knowledgeBaseSelect: knowledgeBaseSelect
    },
    telephone: {
      showCallMenu: showCallMenu,
      call: call
    },
    navigation: {
      setIcon: setIcon,
      setTitle: setTitle,
      setMenu: setMenu,
      close: close,
      replace: replacePage,
      quit: quit,
      setRight: setRight,
      setTitleExpandIcon: setTitleExpandIcon,
      updateExpandTitle: updateExpandTitle,
      setLeft: setLeft,
      goBack: goBack,
      setWindowBig: setWindowBig,
      tencentMeeting: tencentMeeting,
      tencentMeetingBegin: tencentMeetingBegin,
      setPanGestureEnable: setPanGestureEnable
    },
    contact: {
      complexPicker: complexPicker,
      departmentsPicker: departmentsPicker
    },
    group: {
      groupComplexPicker: groupComplexPicker
    },
    chat: {
      chooseConversationByCorpId: chooseConversationByCorpId,
      pickConversation: pickConversation,
      openSingleChat: openSingleChat,
      openTeamChat: openTeamChat,
      openSquad: openSquad,
      sendP2PMsg: sendP2PMsg
    },
    map: {
      view: mapView,
      multipointView: multipointView
    },
    webViewMessage: {
      send: webViewMessageSend
    }
  },
  runtime: {
    permission: {
      requestAuthCode: requestAuthCode
    }
  },
  primary: {
    createTab: createTab,
    weeklyShare: weeklyShare,
    fullScreen: fullScreen,
    exitFullScreen: exitFullScreen
  },
  device: {
    notification: {
      showPreloader: showPreloader,
      hidePreloader: hidePreloader,
      vibrate: vibrate,
      toast: toast,
      alert: alert,
      confirm: confirm,
      actionSheet: actionSheet
    },
    base: {
      getPhoneInfo: getPhoneInfo,
      getUUID: getUUID,
      checkStepPermission: checkStepPermission
    },
    geolocation: {
      get: getGeolocation,
      getSwitch: getGeolocationSwitch
    },
    system: {
      getLang: getLang,
      setLight: setLight
    },
    audio: {
      startRecord: startRecord,
      stopRecord: stopRecord,
      onRecordEnd: onRecordEnd,
      download: downloadAudio,
      play: playAudio,
      pause: pauseAudio,
      stop: stopAudio,
      onPlayEnd: onPlayEnd,
      resume: resumeAudio,
      onRecordEnd_v2: onRecordEnd_v2,
      startRecord_v2: startRecord_v2,
      stopRecord_v2: stopRecord_v2
    },
    connection: {
      getNetworkType: getNetworkType,
      isAtTal: isAtTal
    }
  },
  ui: {
    webViewBounce: {
      disable: webViewBounceDisable
    },
    pullToRefresh: {
      enable: pullToRefreshEnable,
      stop: pullToRefreshStop,
      disable: pullToRefreshDisable
    }
  },
  util: {
    domainStorage: {
      getItem: getItem,
      setItem: setItem,
      removeItem: removeItem
    },
    tool: {
      writeLog: writeLog,
      flushLog: flushLog
    }
  },
  app: {
    custom: {
      talYoungFilesUpload: talYoungFilesUpload
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/index.js
// module id = null
// module chunks = 